import { BrickInfos, brick_registerer } from '@/components/bricks_infos_core.js'
import BrickManualFeatureEngineering from '@/components/brick_manual_feature_engineering.vue'

let infos = new BrickInfos()

infos.back_classes = ['fas', 'fa-circle', 'text-orange']
infos.front_classes = ['fas', 'fa-hand-paper', 'text-white']
infos.name = 'manualfe'
infos.associated_class_name = 'AutomlManualFeatureEngineeredTable'
infos.editing_component_name = 'BrickManualFeatureEngineering'
infos.editing_component = BrickManualFeatureEngineering
infos.descriptions = {
	en: {
		short_tooltip_description: 'Manual FE',
		full_tooltip_description: 'Manual feature engineering',
		navbar_name: 'Manual FE',
	},
	fr: {
		short_tooltip_description: 'FE Manuel',
		full_tooltip_description: 'Feature engineering manuel',
		navbar_name: 'FE Manuel',
	},
}
// infos.short_tooltip_description = 'manualfe_short_tooltip'
// infos.full_tooltip_description = 'manualfe_full_tooltip'
// infos.navbar_name = 'manualfe_navbar'
infos.background_color = 'orange'

brick_registerer(infos)
